import { render } from "./EditTrainConfiguration.vue?vue&type=template&id=2934012f"
import script from "./EditTrainConfiguration.vue?vue&type=script&lang=js"
export * from "./EditTrainConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__